<script>
import entry from '../../entry';
import _ from './_.vue';

const components = { _ };
const map = {
  0: '_',
  1: '_',
  2: '_',
  3: '_',
  4: '_',
  6: '_',
  7: '_'
};

export default entry({
  name: 'course-list-entry',
  components,
  map
});
</script>
